export const joinQP = (arr: Array<{ key: string, value: string | number }>) => {
  const result = arr.reduce((acc, { key, value }) => `${acc}${key}=${encodeURIComponent(value)}&`, '').slice(0, -1);
  return result;
};
